import React from 'react';
import styled from 'styled-components';
import { MAGIC_LINK_FORM_VIEW } from '../BellaForgotPassword';
import { useTranslator } from 'AppShell/hooks';

const Wrapper = styled.ol`
    line-height: 2;
    margin-top: 15px;
`;

type EmailNotRecievedProps = {
    currentView?: string;
};
const EmailNotRecieved = ({ currentView }: EmailNotRecievedProps) => {
    const t = useTranslator();
    return (
        <Wrapper>
            {currentView === MAGIC_LINK_FORM_VIEW ? (
                <li>
                    {t(
                        'We help: Contact customer service at %s0123%s0123%s or write an email to %semail@westwing.xx?subject=subject text%semail@westwing.xx%s',
                        [' ', ' ', ' ', ' ', ' ', ' ', ' ']
                    )}
                </li>
            ) : (
                <>
                    <li>{t('Check in your email inbox folders like Spam, Junk, Social and Promotions.')}</li>
                    <li>
                        {t('Contact our Customer Service under %s or write an email to %s', [
                            t('Phone number'),
                            t('Customer Service Email'),
                        ])}
                    </li>
                </>
            )}
        </Wrapper>
    );
};

export default EmailNotRecieved;
